import { Component, Inject, OnInit } from '@angular/core';
import { Select$ } from '@angular-redux3/store';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { toArray } from '../../utils';
import { Playlist } from '../../store/entities';

@Component({
  selector: 'mwo-playlist-picker',
  templateUrl: './playlist-picker.component.html',
  styleUrls: ['./playlist-picker.component.scss']
})
export class PlaylistPickerComponent implements OnInit {
  @Select$(['playlists', 'events'], toArray) playlists$: Observable<Playlist[]>;
  isNew: boolean;
  name: string;


  constructor(
    private dialogRef: MatDialogRef<PlaylistPickerComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.isNew = data.isNew;
  }

  ngOnInit() {
  }

  selectPlaylist(playlist: Playlist): void {
    this.dialogRef.close(playlist);
  }

  createPlaylist() {
    const id = uuid();
    this.dialogRef.close({ name: this.name, id });
  }
}
